module.exports = {
    props: ['user'],
    data() {
        return {
            isDepartment: false,
            team: null,
            userIsAdmin: false,
            departmentEmailSenderName: this.user.department_email_sender_name
        }
    },
    mounted() {
        this.getDataForAutomation();
    },
    methods: {
        openOffice365Modal(provider) {
            $('#provider').text(provider);
            $('#connectToOffice365Modal').modal('show')
        },
        isEmail(emailAddress){
            let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
            if (emailAddress.match(regex))
                return true;
            else
                return false;
        },
        connectToOffice365(){
            let email = $('#hintEmail').val();
            let nylasOFfice365link = $('#nylasOFfice365link').val();
            // let checkEmail = this.isEmail(email);
            if(email.match( /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/gi)){
                window.location.href = nylasOFfice365link+email;
            }else{
                this.getToast().fire({
                    type: 'error',
                    title: 'Please provide a valid email address.'
                });
            }
        },
        nylasConnectivity(type = 'office365') {
            let self = this;
            axios.post(route('nylas.manage-email-is-departmental'), {isDepartment: this.isDepartment}).then((res) => {
                if(type === 'office365') {
                    self.connectToOffice365();
                }
                else {
                    window.open($('#outlookUrl').val(), "_self");
                }
            });
        },
        getDataForAutomation() {
            let self = this;
            axios.post(route('automation.user-profile.get-data'), {userId: self.user.id}).then((data) => {
                self.team = data.data.team;
                self.userIsAdmin = data.data.userIsAdmin;
            }).catch((error) => {

            });
        },
        saveDepartmentEmailSenderName() {
            let self = this;
            axios.post(route('automation.user-profile.department-email-sender-name.store'), {departmentEmailSenderName: this.departmentEmailSenderName}).then((data) => {
                self.departmentEmailSenderName = data.data.departmentEmailSenderName;
                self.getToast().fire({
                    type: 'success',
                    title: 'Sender name saved successfully.'
                });
            }).catch((error) => {
                //
            });
        }
    }
};
